/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from "./vuetify";
import pinia from "../stores";
import router from "../router";
import * as Sentry from "@sentry/vue";

// Types
import type { App } from "vue";
// import { msalPlugin, msalInstance } from "vue3-msal-plugin";
// import type { Configuration, AuthenticationResult } from "@azure/msal-browser";
// import { EventType } from "@azure/msal-browser";

// import { useUserStore } from "../stores/user";
import { installMsal } from "./msal";
// import { msalPlugin, PublicClientApplication } from '@azure/msal-vue';
import i18n from "../i18n";

export function registerPlugins(app: App) {
  Sentry.init({
    app,
    dsn: "https://1706190abd351b6c283578d6ab4850ef@o4505144855101440.ingest.us.sentry.io/4509129057697792",
    sendDefaultPii: false,
    environment: import.meta.env.MODE,
    integrations: [Sentry.replayIntegration()],
    // Performance monitoring uitgeschakeld
    tracesSampleRate: 0,
    // Session Replay - alleen bij errors
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });

  app.use(vuetify).use(pinia);
  app.use(i18n);
  app.use(router);
  installMsal(app);
}
export { router };
